import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './router/AppRouter';
import { ErrorBoundary } from './shared/components/ErrorBoundary';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <ErrorBoundary>
        <AppRouter />
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
